import { onMounted, onUnmounted, ref } from 'vue';

export function useWindowHeight() {
  const pageHeight = ref(window.innerHeight + 'px');

  const updateHeight = () => {
    pageHeight.value = window.innerHeight + 'px';
  };

  onMounted(() => {
    window.addEventListener('resize', updateHeight);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateHeight);
  });

  return { pageHeight };
}
